document.getElementById("homeGrid")?.addEventListener("click", (e) => {
    // Prevent opening a new lightbox if one already exists
    if (document.querySelector("[data-lightbox-floorplan]")) return;
    if (window.screenSaverClickLock) return;

    // Check if the clicked element is inside a floorplan button
    const imageContainer = e.target.closest('div[data-floorplan-container]');
    if (!imageContainer) return;

    const img = imageContainer.querySelector('img');
    if (!img) return;

    // Prevent multiple triggers
    e.preventDefault();

    // Open the lightbox
    openFloorplanLightbox(img);
});

function openFloorplanLightbox(img) {
    const homeCard = img.closest('div[data-favouritable-card]');
    if (!homeCard) return;

    const formattedData = {
        bedrooms: homeCard.dataset.beds,
        bathrooms: homeCard.dataset.baths,
        alfresco: homeCard.dataset.alfresco ? `${homeCard.dataset.alfresco}m²` : null,
        living: homeCard.dataset.living ? `${homeCard.dataset.living}m²` : null,
        area: homeCard.dataset.area ? `${homeCard.dataset.area}m²` : null,
        blockWidth: homeCard.dataset.blockWidth ? `${homeCard.dataset.blockWidth}m` : null,
        blockDepth: homeCard.dataset.blockDepth ? `${homeCard.dataset.blockDepth}m` : null,
        title: homeCard.dataset.title
    };

    const imageSrc = img.getAttribute('src');
    const lightbox = document.createElement('div');
    lightbox.dataset.lightboxFloorplan = '';
    lightbox.dataset.hidden = 'true';
    lightbox.dataset.visible = 'false';
    lightbox.className =
        "w-full h-full flex items-center ios-vh-fix z-[99999] fixed top-0 left-0 transition-opacity duration-300 backdrop-blur-md data-[visible=false]:pointer-events-none data-[visible=false]:opacity-0 data-[hidden=true]:hidden";

    lightbox.innerHTML = `
        <div class="max-w-full mx-auto relative w-full h-full z-1 p-12 pointer-events-none">
            <div class="w-full h-full relative">
                <img src="${imageSrc}" class="absolute inset-0 w-full h-full object-center object-contain" alt />
            </div>
            <div class="absolute top-0 left-0 w-4/12 p-6">
                <div class="flex flex-col gap-6">
                    <h3 class="text-5xl pt-6 pl-6">${formattedData.title}</h3>
                    <div class="flex gap-10 flex-row justify-start w-full px-6 py-2">
                        <!-- Bedrooms -->
                        <div class="flex flex-col gap-2 items-center justify-center">
                            <div class="w-8 h-8">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" class="w-full h-auto">
                                  <path fill="inherit"
                                        d="M1.524 2c-.168 0-.29.123-.29.296v6.397a3.503 3.503 0 0 1 1.322-.268h.376V6.274c0-.418.338-.755.762-.755h6.81c.423 0 .761.337.761.755v2.151h2.47V6.274c0-.418.337-.755.761-.755h6.81c.424 0 .762.337.762.755v2.151h.376c.467 0 .914.102 1.321.268V2.296c0-.173-.122-.296-.29-.296H1.525Zm1.032 7.343A2.531 2.531 0 0 0 0 11.887v3.882h25v-3.882c0-1.42-1.13-2.544-2.556-2.544H2.556ZM0 22.5v-5.813h25V22.5h-1.852v-3.213a.46.46 0 0 0-.463-.459H2.315a.461.461 0 0 0-.463.46V22.5H0Z"
                                  />
                                </svg>
                            </div>
                            <p class="leading-none text-base">
                                ${formattedData.bedrooms}
                            </p>
                        </div>
                        <!-- Bathrooms -->
                        <div class="flex flex-col gap-2 items-center justify-center">
                            <div class="w-8 h-8">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" class="w-auto h-full mx-auto">
                                    <path fill="inherit"
                                          d="M8.946 12.29 19.788 8A.403.403 0 0 0 20 7.448c-.854-1.79-2.43-2.605-4.219-2.684l-.4-.974a1.205 1.205 0 0 0-1.576-.658l-.801.316C11.83 1.422 9.614.053 7.077 0 3.177-.052 0 3.21 0 7.053v17.21c0 .395.347.737.748.737h1.068c.4 0 .748-.342.748-.737V7c0-2.263 1.709-4.236 3.979-4.447 1.682-.158 3.177.632 4.059 1.869l-.721.289c-.615.237-.935.947-.668 1.553l.4.973c-1.255 1.29-1.789 2.948-1.174 4.816.053.21.293.316.507.237Zm12.791-2.344-.4-.974a.385.385 0 0 0-.534-.21l-12.07 4.736a.375.375 0 0 0-.214.527l.4.973c.08.21.32.316.534.21l12.07-4.762c.214-.08.294-.29.214-.5Zm-8.594 7.664a.995.995 0 0 0 .564-1.3 1.02 1.02 0 0 0-1.32-.556.995.995 0 0 0-.564 1.3c.21.513.8.762 1.32.556Zm4.244-2.772a.995.995 0 0 1-.564 1.3 1.02 1.02 0 0 1-1.32-.555.995.995 0 0 1 .564-1.3 1.02 1.02 0 0 1 1.32.555Zm3.127-.145a.995.995 0 0 0 .564-1.3 1.02 1.02 0 0 0-1.32-.557.995.995 0 0 0-.564 1.3c.209.513.8.762 1.32.557Zm-6.217 4.988a.995.995 0 0 1-.564 1.3 1.02 1.02 0 0 1-1.32-.555.995.995 0 0 1 .564-1.3 1.02 1.02 0 0 1 1.32.555Zm3.784-.434a.995.995 0 0 0 .564-1.3 1.02 1.02 0 0 0-1.32-.556.995.995 0 0 0-.564 1.3c.209.513.8.762 1.32.556Zm4.921-3.01a.995.995 0 0 1-.564 1.3 1.02 1.02 0 0 1-1.32-.555.995.995 0 0 1 .565-1.3 1.02 1.02 0 0 1 1.32.555Zm-8.689 8.092a.995.995 0 0 0 .564-1.3 1.02 1.02 0 0 0-1.32-.556.995.995 0 0 0-.563 1.3c.208.513.8.762 1.32.556Zm5.588-3.276a.995.995 0 0 1-.563 1.3 1.02 1.02 0 0 1-1.32-.555.995.995 0 0 1 .564-1.3 1.02 1.02 0 0 1 1.32.555Zm4.462-.676a.995.995 0 0 0 .564-1.3 1.02 1.02 0 0 0-1.32-.556.995.995 0 0 0-.564 1.3c.21.513.8.762 1.32.556Z"
                                    />
                                </svg>
                            </div>
                            <p class="leading-none text-base">
                                ${formattedData.bathrooms}
                            </p>
                        </div>
                        <!-- Alfresco -->
                        <div class="flex flex-col gap-2 items-center justify-center">
                            <div class="w-8 h-8">
                                <svg width="45" height="36" viewBox="0 0 45 36" xmlns="http://www.w3.org/2000/svg" class="w-full h-auto">
                                  <g fill="inherit">
                                    <path d="m2.323 3.853 8.364-3.1h24.532l8.363 3.1h1.394v2.375H.93V3.853h1.394ZM4.974 31.67h5.85l2.896-2.927-2.095-2.117H9.454v-1.22h.963L7.461 22.42v-2.064H8.67v1.558l3.457 3.492h7.345v1.22h-1.947l-2.095 2.117 2.897 2.926h3.635V21.262h-6.088v-2.006h14.162v2.006h-6.088V31.67h3.634l2.897-2.926-2.095-2.117h-1.947v-1.22h7.346l3.456-3.492v-1.558h1.208v2.064l-2.956 2.986h.963v1.22h-2.17l-2.096 2.117 2.897 2.926h5.847V7.49h2.452v27.97H2.522V7.49h2.452v24.18Zm10.842-5.044h-2.483l1.242 1.255 1.24-1.255Zm-1.241 2.98-2.043 2.063h4.086l-2.043-2.064Zm17.997-2.98h-2.483l1.241 1.255 1.242-1.255Zm-1.242 2.98-2.043 2.063h4.086l-2.043-2.064Z"/>
                                  </g>
                                </svg>
                            </div>
                            <p class="leading-none text-base">
                                ${formattedData.alfresco}
                            </p>
                        </div>
                        <!-- Living Area -->
                        <div class="flex flex-col gap-2 items-center justify-center">
                            <div class="w-8 h-8">
                                <svg width="45" height="34" viewBox="0 0 45 34" xmlns="http://www.w3.org/2000/svg" class="w-full h-auto">
                                  <path d="M44.976 13.33c0-.726-.589-1.314-1.314-1.314h-.122V4.63c0-2.557-2.22-4.56-5.057-4.56H7.423c-2.835 0-5.058 2.003-5.058 4.56v7.386h-.121c-.727 0-1.315.59-1.315 1.315V33.568h3.263v-2.764c0-.486.365-.883.816-.883h35.889c.45 0 .815.395.815.883v2.764h3.263V13.332l.001-.001Zm-6.495 4.518c.48 0 .926.094 1.32.255v2.487H6.103v-2.487a3.478 3.478 0 0 1 1.32-.255h31.06ZM41.408 4.63v7.386h-.29c-.727 0-1.315.59-1.315 1.315v2.537a5.805 5.805 0 0 0-1.32-.152H23.966V2.201h14.517c1.64 0 2.925 1.067 2.925 2.427v.002Zm-36.91 0c0-1.362 1.284-2.428 2.925-2.428h14.516v13.516H7.423c-.459 0-.9.053-1.32.151v-2.537c0-.727-.59-1.314-1.315-1.314h-.29V4.63Z" fill="inherit"/>
                                </svg>
                            </div>
                            <p class="leading-none text-base">
                                ${formattedData.living}
                            </p>
                        </div>
                        <!-- Total Area -->
                        <div class="flex flex-col gap-2 items-center justify-center">
                            <div class="w-8 h-8">
                                <svg width="42" height="35" viewBox="0 0 42 35" xmlns="http://www.w3.org/2000/svg" class="w-full h-auto">
                                    <path d="M5.339 34.426h10.165V23.901c0-.78.62-1.413 1.385-1.413h7.393c.766 0 1.386.632 1.386 1.413v10.525h10.165V15.198l2.392 1.774c.758.562 1.816.39 2.367-.381a1.751 1.751 0 0 0-.374-2.414L21.583.35a1.669 1.669 0 0 0-1.993 0L.955 14.177a1.75 1.75 0 0 0-.374 2.414c.55.772 1.61.943 2.367.381l2.392-1.774v19.228H5.34Z" fill="inherit"/>
                                </svg>
                            </div>
                            <p class="leading-none text-base">
                                ${formattedData.area}
                            </p>
                        </div>
                    </div>
                    
                    <div class="lot-info px-6 flex flex-row justify-start items-center gap-10">
                        <span class="text-base"><span class="font-medium">Lot Width:</span> ${formattedData.blockWidth}</span>
                        <span class="text-base"><span class="font-medium">Lot Depth:</span> ${formattedData.blockDepth}</span>
                    </div>
                </div>
            </div>
        </div>
        <div data-lightbox-backdrop class="absolute top-0 left-0 w-full h-full bg-white/75 z-0"></div>
    `;

    document.body.appendChild(lightbox);
    openLightBox(lightbox);

    // Close lightbox logic
    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');

    const closeHandler = () => {
        closeLightBox(lightbox);
        cleanup();
    };

    const cleanup = () => {
        if (lightboxBackdrop) lightboxBackdrop.removeEventListener('click', closeHandler);
    };

    if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeHandler);
}

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    setTimeout(() => {
        lightbox.remove();
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}
